import React, { useState, useEffect } from "react";

import AboutMe  from "./info-page/about-me";
import FavSites from "./info-page/favorite-sites";
import useScript from "./useScript";
function Blog(props) {
    //routing

    const [favSites, setFavSites] = useState(false); 
    const [embed, setEmbed] = useState([]);
    
  const scrollToSubheading = (subheading) =>{
    document.querySelector(`#${subheading}`).scrollIntoView();
  }

//   useScript('https://koneko-chan.tumblr.com/js');


    return (
    <div id = "about-wrapper" className= {props.blog?'about-wrapper':'page-hidden'}> 
    <button className={favSites?'x-close-favsites':'x-close'} onClick={()=>props.handlePages("main")}>{'<'}--- back to home</button>
     <div className = "title">
            <h1>🍓 blog 🍓</h1>
        </div> 
          <div id="blogholder">
            
          </div>
        </div>
    );
  }

  export default Blog;